import { Chevron, Position } from '@transferwise/components';
import PropTypes from 'prop-types';
import React from 'react';

import componentStyles from './ArrowIcon.module.less';

const Arrow = ({ iconPosition, styles }) => {
  const derivedStyles = { ...componentStyles, ...styles };

  const createClassNames = (classNames) =>
    classNames.map((className) => `${derivedStyles[className]}`).join(' ');

  return (
    <Chevron
      className={createClassNames(['arrow-icon'])}
      orientation={iconPosition === 'up' ? Position.TOP : Position.BOTTOM}
    />
  );
};

Arrow.propTypes = {
  iconPosition: PropTypes.oneOf(['up', 'down']),
};

Arrow.defaultProps = {
  iconPosition: 'down',
};

export default Arrow;
